/* eslint-disable no-invalid-this */
const NS = 'FeaturedBlock';
const CLS = 'featuredBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { trackingScrollMixinBlock } from '../../mixins/trackingScrollMixinBlock/trackingScrollMixinBlock';
import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';

export class FeaturedBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		// Toggle Radio Nav
		if($('input:radio', $(`.${CLS}-nav-toggle-group`)).length) {
			$('input:radio', $(`.${CLS}-nav-toggle-group`)).on('change', function(el) {
				const ref = $(this).data('ref');
				$(`.${CLS}-features-container`).removeClass('show').addClass('hide');
				$(`#${ref}`).removeClass('hide').addClass('show');
			});
		}

		this.initFullWindowHeight(this);
		this.initTrackingScroll(this);
		this.initAnimateScrollReveal(this, CLS);
	}
}

Object.assign(FeaturedBlock.prototype, fullWindowHeightMixinBlock);
Object.assign(FeaturedBlock.prototype, animateScrollRevealMixinBlock);
Object.assign(FeaturedBlock.prototype, trackingScrollMixinBlock);
